import { render, staticRenderFns } from "./LmsDashboard.vue?vue&type=template&id=bfe5a836"
import script from "./LmsDashboard.vue?vue&type=script&lang=js"
export * from "./LmsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports